import {  Pagination } from 'antd';

const itemRender = (_, type, originalElement) => {
  if (type === 'prev') {
    return <a>Previous</a>;
  }
  if (type === 'next') {
    return <a>Next</a>;
  }
  return originalElement;
};

export default ({ currentPage, pageSize, total, onChange }) => {
  return (
    <div className="pagination-container">
      <Pagination
        size="small"
        hideOnSinglePage={true}
        showSizeChanger={false}
        current={currentPage}
        pageSize={pageSize}
        total={total}
        onChange={onChange}
        itemRender={itemRender}
      />
    </div>
  );
};